import * as Yup from 'yup'

export const giftCardSchemaValidation = Yup.object().shape({
  title: Yup.string().label('Title'),
  description: Yup.string().label('Description'),
})
